import {
  apiRequest,
  Dashboard,
  masterWorkUnit,
  Employees,
  Ages,
  EmployeeStatus,
  Jabatan,
  PositionGrade,
  PensiunList,
  Rank,
  PensiunDoneList,
  EmployeeType,
  Gender,
  Religion,
  Marital,
  Blood,
  yearService,
  Education,
  studyAssignment,
  graduationClump,
  Award,
  presensiChart,
  presensiSummary,
  presensiLate,
  presensiCuti,
  punishmentChart,
  punishmentList,
  // Echelon,
  //   Employee,
  // employeeStatistik,
} from '../../../../services/adapters/kepegawaian/dashboardService';

class IndexRepository {
  fetchData = async (query) => {
    return await apiRequest(
      'get',
      Dashboard,
      {
        params: query,
      },
      true
    );
  };

  //FILTER
  fetchWorkUnit = async (query) => {
    return await apiRequest(
      'get',
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  //DATA PEGAWAI
  fetchEmployees = async (query) => {
    return await apiRequest(
      'get',
      Employees,
      {
        params: query,
      },
      true
    );
  };

  fetchAges = async (query) => {
    return await apiRequest(
      'get',
      Ages,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      'get',
      EmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchJabatan = async (query) => {
    return await apiRequest(
      'get',
      Jabatan,
      {
        params: query,
      },
      true
    );
  };

  fetchPositionGrade = async (query) => {
    return await apiRequest(
      'get',
      PositionGrade,
      {
        params: query,
      },
      true
    );
  };

  fetchPensiunList = async (query) => {
    return await apiRequest(
      'get',
      PensiunList,
      {
        body: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      'get',
      Rank,
      {
        params: query,
      },
      true
    );
  };

  fetchPensiunDoneList = async (query) => {
    return await apiRequest(
      'get',
      PensiunDoneList,
      {
        body: query,
      },
      true
    );
  };

  fetchEmployeeType = async (query) => {
    return await apiRequest(
      'get',
      EmployeeType,
      {
        params: query,
      },
      true
    );
  };

  fetchGender = async (query) => {
    return await apiRequest(
      'get',
      Gender,
      {
        params: query,
      },
      true
    );
  };

  fetchReligion = async (query) => {
    return await apiRequest(
      'get',
      Religion,
      {
        params: query,
      },
      true
    );
  };

  fetchMarital = async (query) => {
    return await apiRequest(
      'get',
      Marital,
      {
        params: query,
      },
      true
    );
  };

  fetchBlood = async (query) => {
    return await apiRequest(
      'get',
      Blood,
      {
        params: query,
      },
      true
    );
  };

  fetchYearService = async (query) => {
    return await apiRequest(
      'get',
      yearService,
      {
        params: query,
      },
      true
    );
  };

  fetchEducation = async (query) => {
    return await apiRequest(
      'get',
      Education,
      {
        params: query,
      },
      true
    );
  };

  fetchStudyAssignment = async (query) => {
    return await apiRequest(
      'get',
      studyAssignment,
      {
        params: query,
      },
      true
    );
  };

  fetchGraduationClump = async (query) => {
    return await apiRequest(
      'get',
      graduationClump,
      {
        params: query,
      },
      true
    );
  };

  fetchAward = async (query) => {
    return await apiRequest(
      'get',
      Award,
      {
        params: query,
      },
      true
    );
  };

  //DATA PRESENSI PEGAWAI
  fetchPresensiChart = async (query) => {
    return await apiRequest(
      'get',
      presensiChart,
      {
        params: query,
      },
      true
    );
  };

  fetchPresensiSummary = async (query) => {
    return await apiRequest(
      'get',
      presensiSummary,
      {
        params: query,
      },
      true
    );
  };

  fetchPresensiLate = async (query) => {
    return await apiRequest(
      'get',
      presensiLate,
      {
        params: query,
      },
      true
    );
  };

  fetchPresensiCuti = async (query) => {
    return await apiRequest(
      'get',
      presensiCuti,
      {
        params: query,
      },
      true
    );
  };

  fetchPunishmentChart = async (query) => {
    return await apiRequest(
      'get',
      punishmentChart,
      {
        params: query,
      },
      true
    );
  };

  fetchPunishmentList = async (query) => {
    return await apiRequest(
      'get',
      punishmentList,
      {
        params: query,
      },
      true
    );
  };

  // fetchEmployeeStatistik = async (query) => {
  //     return await apiRequest("get", employeeStatistik, {
  //         params: query
  //     }, true)
  // }

  // fetchEchelon = async (query) => {
  //     return await apiRequest("get", Echelon, {
  //         params: query
  //     }, true)
  // }

  //   fetchEmployee = async (query) => {
  //     return await apiRequest(
  //       'get',
  //       Employee,
  //       {
  //         params: query,
  //       },
  //       true
  //     );
  //   };
}

export default IndexRepository;
